import { Navigate, Outlet } from "react-router-dom";
import { UserManager } from "../../Utilities/UserManager";
import Routing from "./../../Routing/routing";

const PrivateRoute = () => {
  return UserManager.get().isToken() ? <Outlet /> : <Navigate to={Routing.Login} />;
};

export default PrivateRoute;
